<mat-card class="location-context">
    <mat-card-content>
        <!-- Back -->
        <div class="nav-buttons" *ngIf="backButtonAvailable">
          <button class="back" mat-raised-button color="secondary" (click)="redirectBack()" data-cy="back">
            <mat-icon>arrow_back</mat-icon>
            <span>Back</span>
          </button>
        </div>
        
        <!-- Title -->
        <h1 data-cy="title">Centerline Group Selection</h1>
        
        <!-- Select Centerline Group -->
        <div class="selected terminal">
            <span data-cy="selected-terminal">
                Terminal: <strong>{{ selectedTerminal }}</strong>
            </span>
        </div>

        <!-- Centerline Group Selection -->
        <div class="intro">
          <span>Select the centerline group to work on</span>
        </div>
        <div class="buttons">
          <div class="button" *ngFor="let centerlineGroup of centerlineGroups">
            <button mat-raised-button color="primary" (click)="setSelectedCenterlineGroupAndRedirect(centerlineGroup, false)" data-cy="centerline-group">
              {{ centerlineGroup }}
            </button>
          </div>
        </div>
    </mat-card-content>
  </mat-card>